import { useTranslation } from 'react-i18next';
import { Email } from '@material-ui/icons';
import { isGranted } from 'helpers/helpers';
import roles from 'helpers/roles';

import SidebarLinks from '../../SidebarLinks/SidebarLinks';
import getPathSuffixes from '../helpers/getPathSuffixes';

const Communication = () => {
  const { t } = useTranslation();

  const links = [
    isGranted(roles.ROLE_SHOW_MASS_SMS) && {
      name: t('common.mainMenu.sms'),
      to: '/mass-sms',
      additionalActivationPaths: getPathSuffixes('/mass-sms', ['add']),
    },
    isGranted(roles.ROLE_SHOW_MASS_MAIL) && {
      name: t('common.mainMenu.mail'),
      to: '/mass-mails',
      additionalActivationPaths: getPathSuffixes('/mass-mails', ['add']),
    },
    isGranted(roles.ROLE_SHOW_NOTIFICATION) && {
      name: t('common.mainMenu.messages'),
      to: '/messages',
      additionalActivationPaths: getPathSuffixes('/messages', [
        'add',
        'edit/:id',
      ]),
    },
    isGranted(roles.ROLE_SHOW_MAIL_CONFIGURATION) && {
      name: t('common.mainMenu.myCompanyMailNotifications'),
      to: '/mail-notifications',
    },
    isGranted(roles.ROLE_SHOW_SMS_CONFIGURATION) && {
      name: t('common.mainMenu.myCompanySmsNotification'),
      to: '/sms-notifications',
    },
    isGranted(roles.ROLE_SHOW_END_OF_DIET_REMINDER) && {
      name: t('common.mainMenu.myCompanyMailReminders'),
      to: '/mail-reminders',
    },
    isGranted(roles.ROLE_SHOW_END_OF_DIET_REMINDER) && {
      name: t('common.mainMenu.myCompanySmsReminders'),
      to: '/sms-reminders',
    },
    isGranted(roles.ROLE_SHOW_COMMUNICATION_RULE) && {
      name: t('common.mainMenu.communicationRules'),
      to: '/communication-rules',
    },
  ].filter(Boolean);

  if (links.length === 0) {
    return null;
  }

  return (
    <SidebarLinks
      name={t('common.mainMenu.communication')}
      icon={<Email />}
      links={links}
    />
  );
};

export default Communication;
